// extracted by mini-css-extract-plugin
export default {"reset_button":"floating-datepicker_reset_button__sxMQD","container":"floating-datepicker_container__1o2oE"};